import http from './http';
import type { Notification } from '@/types/chat/chat.types';

export const notificationApi = {
  /** Lấy danh sách thông báo của user */
  getMyNotifications: async (): Promise<Notification[]> => {
    const { data } = await http.get('/notifications/user');
    return data.data ?? data;
  },

  /** Lấy chi tiết thông báo */
  getNotification: async (id: string): Promise<Notification> => {
    const { data } = await http.get(`/notifications/${id}`);
    return data.data ?? data;
  },

  /** Đánh dấu đã đọc */
  markRead: async (notificationId: string): Promise<void> => {
    await http.post('/notifications/mark-read', { notificationId });
  },
};
